"use client";
import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import styled from 'styled-components';
import {hardGray, text, white} from '@/styles/globalStyleVars';
import {Img} from "@/components/common/ui/Img";
import reactHtmlParser from "react-html-parser";
import useContainerOffset from "@/components/hooks/useContainerOffset";
import CottationWhite from "@/components/common/ui/icons/CottationWhite";

/**
 * Testimonial Type one component section
 * Pass the props with your data to the Testimonial Type one component.
 * Check the page folder to see the components used.
 **/
const Directors = ({background, data, padding, reverse}) => {
    /**
     * variables
     * Change / add your custom variable
     **/
    const offset = useContainerOffset('.container')


    return (
        <StyledDirectors
            offsetStyle={offset}
            background={background}
            className={`person_message ${padding ? padding : 'pt-200'}  ${ data?.section_data?.reverse === 'key1' ? 'pb-200' : ''} as-image-text-slider`}
        >
            <Container>
                <div className="wrapper-man">


                    {
                        data?.section_data?.reverse === 'key1' ?
                            <Row className={'yes-revers'}>

                                <Col md={{span: 4}}>
                                    <div className="image_wrapper ">
                                        <Img alt={reactHtmlParser(data?.section_data?.title)} src={data?.images?.list?.[0]?.full_path}/>
                                    </div>
                                </Col>
                                <Col md={{span: 6, offset: 1}}>
                                    <div className="content">
                                        <CottationWhite/>


                                        {
                                            data?.section_data?.description &&
                                            reactHtmlParser(data?.section_data?.description)
                                        }
                                        <div className="designation">
                                            {
                                                data?.section_data?.title &&
                                                <h5 className={'split-up'}>{reactHtmlParser(data?.section_data?.title)}</h5>
                                            }
                                            {
                                                data?.section_data?.subtitle &&
                                                <p className={'split-up'}>{reactHtmlParser(data?.section_data?.subtitle)}</p>
                                            }
                                        </div>
                                    </div>
                                </Col>

                            </Row>
                            :
                            <Row className={'no-revers'}>
                                <Col md={7}>
                                    <div className="content">
                                        <CottationWhite/>

                                        {
                                            data?.section_data?.description &&
                                            reactHtmlParser(data?.section_data?.description)
                                        }
                                        <div className="designation">
                                            {
                                                data?.section_data?.title &&
                                                <h5 className={'split-up'}>{reactHtmlParser(data?.section_data?.title)}</h5>
                                            }
                                            {
                                                data?.section_data?.subtitle &&
                                                <p className={'split-up'}>{reactHtmlParser(data?.section_data?.subtitle)}</p>
                                            }
                                        </div>
                                    </div>
                                </Col>
                                <Col md={{span: 4, offset: 1}}>
                                    <div className="image_wrapper ">
                                        <Img src={data?.images?.list?.[0]?.full_path} alt={reactHtmlParser(data?.section_data?.title)}/>
                                    </div>
                                </Col>


                            </Row>
                    }
                </div>
            </Container>
        </StyledDirectors>
    );
};

/**
 * Styled component for Testimonial Type one component section
 * Add your styles for Testimonial Type one component here.
 **/
const StyledDirectors = styled.section`
    background: ${text};

    .wrapper-man {
        padding: 70px;
        border: 1px solid ${white};
        border-radius: 10px;

        .content {
            svg {
                margin-bottom: 40px;
            }

            p {
                color: ${hardGray};
            }

            .designation {
                margin-top: 50px;

                h5 {
                    font-size: 20px;
                    font-weight: 500;
                    line-height: 24px;
                    color: ${white};

                }

                p {
                    font-weight: 300;
                    color: ${white};

                }
            }
        }

        .image_wrapper {
            padding-top: calc(390 / 300 * 100%);
            position: relative;

            .global-image {
                border-radius: 10px;
                overflow: hidden;
            }
        }
    }


    @media (max-width: 992px) {
        .wrapper-man {
            .col-md-6, .col-md-5 {
                flex: 0 0 100%;
                max-width: 100%;
                margin: 0;
                padding: 0;
            }

            .yes-revers {

                .col-md-5 {
                    margin-bottom: 30px;
                }
            }

            .no-revers {
                flex-direction: column-reverse;

                .col-md-5 {
                    margin-bottom: 30px;
                }
            }
        }

    }

    @media (max-width: 767px) {
        
        .content{
            margin-top: 40px;
        }
        .wrapper-man {
            padding: 15px;

            .col-md-6, .col-md-5 {

                padding: 0 15px;
            }
        }
    }
`;

export default React.memo(Directors);
